import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import moment from 'moment';
import React, { useEffect } from 'react';
import { DatePicker } from '../../..';
import { FilterRow } from './FilterComponentFactory';
import { OperatorComponent } from './OperatorComponent';
import MomentUtils from '@date-io/moment';
export var DateFilterComponent = function DateFilterComponent(props) {
  var stateKey = props.stateKey,
      state = props.state,
      stateChangeFn = props.stateChangeFn,
      dsComponentProps = props.dsComponentProps;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      selectedDate = _React$useState2[0],
      setDate = _React$useState2[1];

  useEffect(function () {
    if (state[stateKey].value) {
      setDate(moment(state[stateKey].value));
    } else if (state[stateKey].value === null) {
      setDate(null);
    }
  }, [state]);
  return /*#__PURE__*/React.createElement(FilterRow, null, /*#__PURE__*/React.createElement(DatePicker, _extends({}, dsComponentProps, {
    utils: MomentUtils,
    format: "MM/DD/YYYY",
    label: state[stateKey].label || stateKey,
    value: selectedDate,
    dsOnChange: function dsOnChange(val) {
      stateChangeFn(_objectSpread(_objectSpread({}, state), {}, _defineProperty({}, stateKey, _objectSpread(_objectSpread({}, state[stateKey]), {}, {
        value: val
      }))));
    }
  })), /*#__PURE__*/React.createElement(OperatorComponent, props));
};

try {
  DateFilterComponent.__docgenInfo = {
    description: '',
    displayName: 'DateFilterComponent',
    methods: [],
    props: {}
  };
} catch (e) {}
//# sourceMappingURL=DateFilterComponent.js.map